<div class="footer fixed-bottom">   
    <footer>
        <div class="p-3">RCS Copyright © {{currentYear}} {{version}} </div>      
    </footer>    
</div>